<template>
  <v-stepper v-model="step" elevation="0">    
    <v-stepper-header elevation="0" style="box-shadow: none;">
      <v-stepper-step :complete="step > 1" step="1" color="success">
        Veículos        
        <small>Placas dos veículos 
          <br> 
          <span v-if="vehiclesSetence">{{ vehiclesSetence }}</span>
          <span v-else>Nenhum veículo selecionado</span>
        </small>
      </v-stepper-step>

      <v-stepper-step :complete="step > 2" step="2" color="success">
        Pagamento <span v-if="group">R$ {{ group.total_amount}}</span>
        <small>Forma de pagamento</small>
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-form ref="newOrderForm" lazy-validation @submit.prevent="onSubmit">
          <v-row>
            <v-col :lg="12" :md="12" :sm="12" :xs="12">
              <OrderVehicleAutoComplete v-model="vehicles" />              
            </v-col>
          </v-row>    
          <v-btn depressed color="success" type="submit">
            Continuar
          </v-btn>    
        </v-form>        
      </v-stepper-content>

      <v-stepper-content step="2">        
        <GroupPaymentForm v-if="group" :group="group" />          
      </v-stepper-content>
    </v-stepper-items>   
  </v-stepper>
</template>

<script>
import GroupPaymentForm from './GroupPaymentForm.vue';
import OrderService from '@/services/order.service';
import PaymentService from '@/services/pagamento.service';
import OrderVehicleAutoComplete from './OrderVehicleAutoComplete.vue';

export default {
  name: "OrderCheckoutTacographCertificateRenewal",
  
  components: {
    OrderVehicleAutoComplete,
    GroupPaymentForm
  },

  data: () => ({
    vehicles: [],
    vehiclesSetence: null,

    step: 1,

    group: null, 
    
    orders: [],

    orderKind: null,
  }),

  watch: {
    vehicles() {
      this.setVehiclesSetence();
    }
  },

  methods: {
    onSubmit() {
      if (!this.$refs.newOrderForm.validate()) return;      

      OrderService
        .bulkCreate(this.bulkCreatePayload())
        .subscribe(({data}) => {
          this.group = data.group;
          this.onEventOrderCreated();
      });
    },

    bulkCreatePayload() {      
      return {
        kind: 'RENOVACAO_CERTIFICADO_TACOGRAFO',
        data: {
          vehicles: this.vehicles.map(vehicle => ({
            plate: vehicle.plate,
            transport_id: vehicle.transportId
          }))
        }
      }
    },

    setVehiclesSetence() {      
      this.vehiclesSetence = this.vehicles.map(vehicle => vehicle.plate).join(', ');
    },

    onEventOrderCreated() {
      this.step = 2;
    },

    fetchOrders() {
      const params = {
        input: {
          group: this.group.id
        }        
      }
      
      OrderService
        .list(params)
        .subscribe({
          next: ({items}) => {            
            this.orders = items;
          }
      });
    }
  },
};
</script>